import Skeleton from '@passkeys/ui/skeleton';

import Image from '@/ui/components/image';
import type { Nft } from '@/ui/types';

export interface HeroProps {
  collectible: Nft;
}

function Hero({ collectible }: HeroProps) {
  return (
    <div className="flex flex-col items-center">
      {collectible ? (
        <Image src={collectible.image} className="w-[80px] rounded-[20px]" />
      ) : (
        <Skeleton width={80} height={80} borderRadius={20} />
      )}
    </div>
  );
}

export default Hero;
